import { UploadData, UploadStoreState } from '../../../../store/uploadStore';
import { UploadType } from '../../../../consts/uploadType';
import { getQueuedAndRegisteringFileCount } from '../helpers/queues';

export const getInterruptedUploads = (
  currentUploads: UploadData[],
  getRegistrationRequests: UploadStoreState['getRegistrationRequests'],
) => {
  return currentUploads.filter((upload) => {
    const registrationRequests = upload.upload
      ? getRegistrationRequests(
          upload.meta.type === UploadType.Pano,
          upload.upload.customer,
          upload.upload.site,
          upload.overview.flightScheduleId,
        )
      : undefined;
    const queuedAndRegisteringFileCount = getQueuedAndRegisteringFileCount(upload, registrationRequests);

    return upload.overview.photosCount.uploaded + queuedAndRegisteringFileCount !== upload.overview.photosCount.all;
  });
};
